/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Button, InputGroup, Alert,
} from 'reactstrap';

import * as url from '../../helpers/url_helper';
import BaseGrid from '../Common/BaseGrid';
import { get } from '../../helpers/api_helper';

function ContactSelector(props) {
  const { entity } = props;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [contact, setContact] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await get(`${url.GET_DIRECTORY_ENTRY}/${entity}`);

        setContact(result);
        setLoading(false);
      } catch (e) {
        setError(e.message);
        setLoading(false);
      }
    };

    if (typeof entity === 'number') {
      fetchData();
    } else {
      setContact(entity);
      setLoading(false);
    }
  }, []);

  const jsx = (
    <div>
      {entity == null && loading === false && (
        <BaseGrid
          url={url.GET_DIRECTORY_ENTRIES}
          hasSearch
          skipSort
          shouldPaginate={false}
          config={
            {
              columns: {
                id: { label: props.t('ID'), sort: true },
                name: { label: props.t('Name'), sort: true },
                email: { label: props.t('Email'), sort: true },
                actions: {
                  label: props.t('Actions'),
                  actions: [
                    {
                      key: 'select',
                      icon: 'mdi mdi-check-bold',
                      class: 'btn btn btn-sm btn-soft-dark',
                      type: 'button',
                      alt: props.t('Select'),
                      click: (ent) => {
                        props.onChange(ent);
                        setContact(ent);
                      },
                    },
                  ],
                },
              },
              pagination: {
                sort: 'id',
                direction: 'desc',
                perPage: 3,
              },
            }
          }
        />
      )}

      {contact != null && loading === false && (
        <div>
          <InputGroup>
            <input readOnly className="form-control" value={`${contact.name} - ${contact.email}`} />
            <Button
              className="btn btn-danger"
              type="button"
              onClick={(ent) => {
                props.onRemove(ent);
                setContact(null);
              }}
            >
              <span className="mdi mdi-close-thick" />
            </Button>
          </InputGroup>
        </div>
      )}

      {(loading || error) && (
        <div>
          <InputGroup>
            {error !== false && (
              <Alert>{error}</Alert>
            )}
            {loading !== false && (
              <input readOnly className="form-control" value={props.t('Loading...')} />
            )}
            <Button
              className="btn btn-danger"
              type="button"
              disabled
            >
              <span className="mdi mdi-close-thick" />
            </Button>
          </InputGroup>
        </div>
      )}
    </div>
  );

  return jsx;
}

ContactSelector.defaultProps = {
  onChange: () => {},
  onRemove: () => {},
  entity: null,
};

ContactSelector.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  entity: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ContactSelector));
